import { List, Map } from 'immutable';

import { ATTRIBUTE } from '../../../../constants/attributes';

export function hsCode({ preview }) {
  return {
    payload: Map({
      type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
      value: List([
        Map({
          combination: null,
          offeringId: null,
          value: Map({
            [ATTRIBUTE.HS_CODE]: preview.getIn([ATTRIBUTE.SHIPPING, ATTRIBUTE.HS_CODE]),
          }),
        }),
      ]),
    }),
  };
}
